<div>
  @if (isControllerDisconnected) {
    <div class="alert-banner-container">
      <app-alert-banner></app-alert-banner>
    </div>
  }
  @if (thermostatFeatureDetailsLoadComplete) {
    <div class="container">
      <img class="backArrow" src="assets/img/ic_back.svg" (click)="navigateBack()">
      <span class="title-styling">
        {{thermostatFeatureName}}
      </span>
      <div class="border-style mt-4" style="padding: 10px;">
        <div class="row" style="padding: 15px;">
          <div class="col-12">
            <div>
              <img width="32px" [src]="thermostatIconSrc" >
              <span class="title-styling">
                {{thermostatFeatureName}}
              </span>
            </div>
          </div>
        </div>
        <div class="row" style="margin-left: 5px; margin-bottom:10px;">
          <div class="col-3 thermostat-details">
            <div class="thermostat-details">
              <div class="thermostat-name">
                <div style="margin-bottom: 10px;">
                  {{'lang.feature_status' | translate }}
                </div>
                <div class="thermostat-style">
                  <span class="thermostat-sub-title">
                    {{'lang.thermostat_status' | translate }}
                  </span> <br>
                  <span >
                    <span class="thermostat-sub-title-value">
                      {{ getThermostatState() }}
                      @if (getThermostatState() === 'On') {
                        <span>
                          | {{ getThermostatOperationStatus() }}
                        </span>
                      }
                    </span>
                  </span>
                </div>
                <br>
                  <div class="thermostat-style">
                    <span class="thermostat-sub-title">
                      {{'lang.activation_reason' | translate}}
                    </span> <br>
                    <span class="thermostat-sub-title-value"> {{ activationReasonMap[getThermostatActivationReason()] || '-' }} </span>
                  </div>
                </div>
              </div>
              <div class="thermostat-details">
                <div class="thermostat-name">
                  <div  style="margin-bottom: 10px;">
                    {{'lang.feature_details' | translate }}
                  </div>
                  <div class="thermostat-style">
                    <span class="thermostat-sub-title">{{'lang.controller' | translate }}</span> <br>
                    <span class="thermostat-sub-title-value"> {{'lang.iAqualink_edge' | translate }}</span><br>
                    <span class="thermostat-sub-title-value">
                      <a class="thermostat-details-value" [routerLink]="['../../../equipment/controller/', thermostatFeatureDetails?.controllerData?.controllerSerialNumber]">
                        {{thermostatFeatureDetails?.controllerData?.controllerSerialNumber}}
                      </a>
                    </span>
                  </div>
                  <br>
                    <div class="thermostat-style">
                      <span class="thermostat-sub-title">{{'lang.spaces' | translate }}</span> <br>
                      <span class="thermostat-sub-title-value">
                        <span class="thermostat-details-value">
                          {{ getThermostatSpaceName() }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="thermostat-details">
                  <div class="thermostat-name">
                    <div  style="margin-bottom: 10px;">
                      {{'lang.site_details' | translate }}
                    </div>
                    <div class="thermostat-style">
                      <span class="thermostat-sub-title">{{'lang.site_name' | translate }}</span> <br>
                      <span class="thermostat-sub-title-value">
                        <a  class="thermostat-details-value" [title]="thermostatFeatureDetails?.site?.siteName" [routerLink]="['../../../sites/detail/', thermostatFeatureDetails?.site?.siteId]">
                          {{ thermostatFeatureDetails?.site?.siteName | slice:0:30 }}{{ thermostatFeatureDetails?.site?.siteName?.length > 30 ? '...' : '' }}
                        </a>
                      </span>
                    </div>
                    <br>
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <div>
                    <tabset class="m-0">
                      <tab class="siteusers" heading="{{'lang.status' | translate}}"(selectTab)="onSelect($event)">
                        <div class="siteuser">
                          <app-thermostat-status [thermostatFeatureStatus]="thermostatFeatureStatusTab" [spaceId]="thermostatFeatureDetails.spaces.id"></app-thermostat-status>
                        </div>
                      </tab>
                      <tab class="siteusers" heading="{{'lang.source_priority' | translate}}" (selectTab)="onSelect($event)">
                        <div class="siteuser">
                          <app-thermostat-source-priority [thermostatFeatureSourcePriorities]="thermostatFeatureSourcePriorities"></app-thermostat-source-priority>
                        </div>
                      </tab>
                    </tabset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
